module.exports = __webpack_public_path__ + "static/media/user-astronaut.b4c8faf1.svg";